module.exports = __webpack_public_path__ + "img/risk-management-graphic.540378cb.svg";